import MuiListItemIcon from "@mui/material/ListItemIcon";
const ListItemIcon = MuiListItemIcon;
export default ListItemIcon;
